import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["backdrop", "content"]
  static values = { 
    closeOnEscape: { type: Boolean, default: true },
    closeOnBackdrop: { type: Boolean, default: true }
  }
  
  connect() {
    // Bind the keydown handler to maintain context
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }
  
  disconnect() {
    this.close()
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }
  
  open(event) {
    // Prevent default if this was triggered by a button
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    // Show modal
    this.element.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    
    // Add event listeners
    if (this.closeOnEscapeValue) {
      document.addEventListener("keydown", this.boundHandleKeydown)
    }
    
    // Animate in
    requestAnimationFrame(() => {
      if (this.hasBackdropTarget) {
        this.backdropTarget.classList.remove("opacity-0")
        this.backdropTarget.classList.add("opacity-100")
      }
      
      if (this.hasContentTarget) {
        this.contentTarget.classList.remove("opacity-0", "scale-95")
        this.contentTarget.classList.add("opacity-100", "scale-100")
      }
    })
    
    // Dispatch event
    this.dispatch("opened")
  }
  
  close(event) {
    // Prevent default and stop propagation if triggered by a button/link
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    // Animate out
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("opacity-100")
      this.backdropTarget.classList.add("opacity-0")
    }
    
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("opacity-100", "scale-100")
      this.contentTarget.classList.add("opacity-0", "scale-95")
    }
    
    // Hide modal after animation
    setTimeout(() => {
      this.element.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
      
      // Remove event listeners
      document.removeEventListener("keydown", this.boundHandleKeydown)
      
      // Dispatch event
      this.dispatch("closed")
    }, 150) // Match transition duration
  }
  
  toggle(event) {
    if (this.element.classList.contains("hidden")) {
      this.open(event)
    } else {
      this.close(event)
    }
  }
  
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
  
  handleBackdropClick(event) {
    if (this.closeOnBackdropValue && event.target === event.currentTarget) {
      this.close(event)
    }
  }
}
